<crm-auto-complete
  [(value)]="selectedBankDetail"
  (valueChange)="selectedBankDetailChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  [disabled]="disabled"
  [inputStyle]="inputStyle"
  [suggestions]="bankDetails"
  [field]="field"
  [virtualScroll]="true"
  [virtualScrollItemSize]="64"
  [inputStyleClass]="inputStyleClass"
  dataKey="id"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [isError]="isError"
  (completeMethod)="customSearch ? bankDetailsSearch.emit($event.query) : searchBankDetails($event.query)">
  <ng-template
    let-item="item"
    #itemTemplate>
    <div
      *ngIf="toBankDetail(item) as bankDetail"
      class="white-space-normal">
      <div class="mb-1">{{ bankDetail?.name }}</div>
      <div class="text-gray-500">{{ bankDetail.checkingAccount }}</div>
    </div>
  </ng-template>
</crm-auto-complete>
